import { setDefaultAssets } from '@leagueplatform/asset-config';
import { REWARDS_EVENTS_ASSETS } from './asset-map';

export const initModule = () => {
  setDefaultAssets(REWARDS_EVENTS_ASSETS);
};
